import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

type ChecklistIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const ChecklistIcon: React.FC<ChecklistIconProps> = ({
  title = 'Storefront',
  viewBox = '0 0 24 24',
  ...props
}) => (
  <CreateIconComponent viewBox={viewBox} title={title} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.53322 6.4C4.53322 7.1732 3.90641 7.8 3.13322 7.8C2.36002 7.8 1.73322 7.1732 1.73322 6.4C1.73322 5.6268 2.36002 5 3.13322 5C3.90641 5 4.53322 5.6268 4.53322 6.4ZM4.53322 11.9995C4.53322 12.7727 3.90641 13.3995 3.13322 13.3995C2.36002 13.3995 1.73322 12.7727 1.73322 11.9995C1.73322 11.2263 2.36002 10.5995 3.13322 10.5995C3.90641 10.5995 4.53322 11.2263 4.53322 11.9995ZM3.13322 19.0003C3.90641 19.0003 4.53322 18.3735 4.53322 17.6003C4.53322 16.8271 3.90641 16.2003 3.13322 16.2003C2.36002 16.2003 1.73322 16.8271 1.73322 17.6003C1.73322 18.3735 2.36002 19.0003 3.13322 19.0003ZM22.2665 11.9995C22.2665 11.2263 21.6397 10.5995 20.8665 10.5995H7.33315L7.25089 10.6019C6.51598 10.6444 5.93315 11.2539 5.93315 11.9995C5.93315 12.7727 6.55995 13.3995 7.33315 13.3995H20.8665L20.9487 13.3971C21.6837 13.3545 22.2665 12.7451 22.2665 11.9995ZM20.8665 5C21.6397 5 22.2665 5.6268 22.2665 6.4C22.2665 7.14558 21.6837 7.75504 20.9487 7.79762L20.8665 7.8H7.33315C6.55995 7.8 5.93315 7.1732 5.93315 6.4C5.93315 5.65442 6.51598 5.04496 7.25089 5.00238L7.33315 5H20.8665ZM22.2665 17.6003C22.2665 16.8271 21.6397 16.2003 20.8665 16.2003H7.33315L7.25089 16.2026C6.51598 16.2452 5.93315 16.8547 5.93315 17.6003C5.93315 18.3735 6.55995 19.0003 7.33315 19.0003H20.8665L20.9487 18.9979C21.6837 18.9553 22.2665 18.3458 22.2665 17.6003Z"
    />
  </CreateIconComponent>
);

export default ChecklistIcon;
